import { Link } from "react-router-dom";
import styled from "styled-components/macro";

import { ReactComponent as ArrowIcon } from "../../../assets/icons/icon_arrow.svg";

export const Card = styled.article`
  border-radius: 24px;
  border: 1px solid #B4B4B4;
  overflow: hidden;
  background-color: #fff;
`

export const CardHeader = styled.div<{tabType?: string}>`
  width: 100%;
  height: 25px;  
  background-color:${({ tabType }) => (tabType === "consulting" ? "#C7E8E8" : "#BCD3FF")};
`

export const CategoryContainer = styled.div`
  padding: 0 24px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  height: 45px;

  @media (max-width: 979px) {
    padding: 0 16px;
  }
`

export const TitleContainer = styled.div`
  padding: 0 24px;
  margin-bottom: 24px;
  height: 68px;

  @media (max-width: 979px) {
    padding: 0 16px;
  }
`

export const PriceContainer = styled.div`
  height: 173px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;

  @media (max-width: 979px) {
    padding: 16px;
  }
`

export const ButtonContainer = styled.div`
  padding: 24px;
`

export const Circle = styled.div<{tabType?: string}>`
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${({ tabType }) => (tabType === "consulting" ? "#C7E8E8" : "#BCD3FF")};
`

export const Category = styled.span`
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;

  @media (max-width: 979px) {
    font-size: 13px;
  }
`

export const Title = styled.span`
  width: 100%;
  font-size: 35px;
  font-family: "Cormorant Infant", sans-serif;
  font-weight: 600;
  display: block;
  line-height: 100%;

  @media (max-width: 979px) {
    font-size: 30px;
  }
`

export const Divider = styled.div`
  width: 100%;
  border-top: 1px dashed #B4B4B4;
`

export const Description = styled.p`
  font-size: 18px;
  line-height: 20px;
  height: 224px;
  padding: 24px;

  @media (max-width: 979px) {
    font-size: 15px;
    padding: 16px;
  }
`

export const Meeting = styled.span`
  font-size: 18px;
  
  @media (max-width: 979px) {
    font-size: 15px;
  }
`

export const Price = styled.span<{textLength:number}>`
  font-size: ${(
      props => 35 
          - (props.textLength > 8 ? 3 : 0) 
          - (props.textLength > 10 ? 2 : 0)
          - (props.textLength > 11 ? 2 : 0)
  )}px;
  font-family: "Cormorant Infant", sans-serif;
    
  @media (max-width: 979px) {
    font-size: 30px;
  }
`

export const Tag = styled.span`
  background-color: #BFDCF5;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  width: max-content;
  margin-top: auto;
`

export const Icon = styled(ArrowIcon)`
  width: 24px;
  height: 24px;
  transition: 0.2s;
`

export const Button = styled(Link)`
  padding: 18px 0;
  color: inherit;
  font-weight: 500;
  background-color: #F8F8F8;
  border: 1px solid #141414;
  height: 54px;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  line-height: 18px;
  text-decoration: none;
  transition: 0.2s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  
  &:hover {
    background-color: #000;
    color: #fff;
    transition: 0.2s;
    border: 1px solid #000;
  }

  &:hover ${Icon} {
     path {
       fill: #fff;
       transition: 0.2s;
     }
  }
`

